import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './ExpandDataButton.less';

const I18N = defineMessages({
  EXPAND: {
    id: 'common.expandDataButton.expand',
    defaultMessage:
      'show {count, plural, one {# more change} other {# more changes}}',
    description: 'title text for expand data button',
  },
  COLLAPSE: {
    id: 'common.expandDataButton.collapse',
    defaultMessage: 'hide {count, plural, one {# change} other {# changes}}',
    description: 'title text for collapse data button',
  },
});

const ExpandDataButton = ({
  className,
  dataLength,
  disabled,
  expandCallback,
  intl,
  isExpanded,
  item,
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    if (disabled) {
      event.preventDefault();
    } else {
      expandCallback(item);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      if (disabled) {
        event.preventDefault();
      } else {
        expandCallback(item);
      }
    }
    return true;
  };

  const count = dataLength > 0 ? dataLength - 1 : 0;
  const text = utils.TranslateUtils.translate(
    isExpanded ? I18N.COLLAPSE : I18N.EXPAND,
    intl,
    {
      count,
    }
  );

  return (
    <div
      className={classNames(className, styles.dlExpandDataButton, {
        [styles.dlDisabled]: disabled,
      })}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
      role={'button'}
      title={text}
    >
      {text}
      <i
        className={classNames(styles.dlExpandDataButtonIcon, 'fas', {
          'fa-angle-double-up': isExpanded,
          'fa-angle-double-down': !isExpanded,
        })}
      />
    </div>
  );
};

ExpandDataButton.displayName = 'ExpandDataButton';

ExpandDataButton.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  dataLength: PropTypes.number,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
  isExpanded: PropTypes.bool,
  item: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.objectOf(PropTypes.any),
  ]),
  expandCallback: PropTypes.func.isRequired,
};

ExpandDataButton.defaultProps = {
  className: '',
  dataLength: 0,
  disabled: false,
  isExpanded: true,
  item: undefined,
};

export default injectIntl(ExpandDataButton);
